var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"b-icon bi",attrs:{"xmlns":"http://www.w3.org/2000/svg","focusable":"false","role":"img","viewBox":"0 0 40 40","fill":_vm.color}},[_c('path',{attrs:{"d":_vm.path}})])}
var staticRenderFns = []

export { render, staticRenderFns }